/**
 * WeekLockBanner.tsx - Admin-controlled week lock status banner
 * Beta v2 - Users cannot self-lock; admin controls lock
 * 
 * Shows lock status on key screens:
 * - Build Roster (PortfolioView)
 * - Review (ReviewView)
 * - Leaderboard
 * - Game Plan (StrategyHub)
 */

import React from 'react';
import { Lock, Unlock } from 'lucide-react';

interface WeekLockBannerProps {
  isLocked: boolean;
  lockTime?: string | null;
}

export function WeekLockBanner({ isLocked, lockTime }: WeekLockBannerProps) {
  if (isLocked) {
    return (
      <div className="mx-3 mt-3 bg-slate-100 border border-slate-300 rounded-xl p-3 flex items-center gap-2">
        <Lock size={16} className="text-slate-500" />
        <p className="text-xs text-slate-600 font-medium">
          Week locked. Rosters are final.
        </p>
      </div>
    );
  }

  return (
    <div className="mx-3 mt-3 bg-amber-50 border border-amber-200 rounded-xl p-3 flex items-center gap-2">
      <Unlock size={16} className="text-amber-500" />
      <p className="text-xs text-amber-700">
        Edits allowed until admin locks the week.
        {lockTime && (
          <span className="ml-1 font-medium">
            Lock scheduled: {new Date(lockTime).toLocaleString()}
          </span>
        )}
      </p>
    </div>
  );
}

export default WeekLockBanner;
